import CardFilter from "./fragments/CardFilter/CardFilter.fragment";
import { 
  useFilterContext,
  CategoryEnum, 
} from "@pages/Dashboard/contexts/Filter.context";

import styles from "./Sidebar.module.scss";

const Sidebar: React.FC = () => {
  const { 
    category, 
    setCategory, 
    sidebarMetrics: { 
      size, 
      queue, 
      progress, 
      delay, 
      finished,
    },
  } = useFilterContext();

  return (
    <aside className={styles.sidebar}>
      <CardFilter 
        icon="file" 
        label="Etapas" 
        value={size} 
        onClick={() => setCategory(undefined)} />

      <CardFilter
        icon="warning" 
        label="Com atraso" 
        value={delay} 
        select={category === CategoryEnum.late}
        onClick={() => setCategory(CategoryEnum.late)} />

      <CardFilter 
        icon="loader" 
        label="Em andamento" 
        value={progress}
        select={category === CategoryEnum.progress}
        onClick={() => setCategory(CategoryEnum.progress)} />

      <CardFilter 
        icon="time" 
        label="Na fila" 
        value={queue}
        select={category === CategoryEnum.queue}
        onClick={() => setCategory(CategoryEnum.queue)} />

      <CardFilter 
        icon="check" 
        label="Finalizados" 
        value={finished} 
        className="text--success--400"
        select={category === CategoryEnum.finished}
        onClick={() => setCategory(CategoryEnum.finished)} />
    </aside>
  );
};

export default Sidebar;